module.exports = __webpack_public_path__ + "static/img/2_2.154e4f73.jpg";